import { BarChart3 } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const reportsNav: NavEntry = {
  label: 'Reports',
  icon: BarChart3,
  path: '/reports',
  permission: 'reports:read',
  order: 7,
}
